import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticPostalCodeInput,
    DeleteLogisticPostalCodeInput,
    LogisticPostalCode,
    UpdateLogisticPostalCodeInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticPostalCodeService {
    private amplifyClient = generateClient();
    constructor() {}

    async getLogisticPostalCode(id: string): Promise<LogisticPostalCode> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getLogisticPostalCode,
                    variables: {
                        id
                    }
                })
            ).data.getLogisticPostalCode;
            if (data) return data as LogisticPostalCode;
        } catch (error) {
            console.error('Error finding LogisticPostalCode:', error);
            return null;
        }
    }

    async listLogisticPostalCodes(): Promise<LogisticPostalCode[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticPostalCodes
                })
            ).data.listLogisticPostalCodes.items;
            if (data) return data as LogisticPostalCode[];
        } catch (error) {
            console.error('Error finding PrintLogos:', error);
            return null;
        }
    }

    async listAllLogisticPostalCodes(
        pageLimit: number = 100
    ): Promise<LogisticPostalCode[]> {
        const codes: LogisticPostalCode[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticPostalCodes,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticPostalCodes;
                codes.push(
                    ...((response?.items ?? []) as LogisticPostalCode[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return codes;
        } catch (error) {
            console.error('Error finding LogisticPostalCode:', error);
            return [];
        }
    }

    async createLogisticPostalCode(
        input: CreateLogisticPostalCodeInput
    ): Promise<LogisticPostalCode> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticPostalCode,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticPostalCode;
            if (date) return date as LogisticPostalCode;
        } catch (error) {
            console.error('Error creating LogisticPostalCode:', error);
            return null;
        }
    }
    async updateLogisticPostalCode(
        input: UpdateLogisticPostalCodeInput
    ): Promise<LogisticPostalCode> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticPostalCode,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticPostalCode;
            if (date) return date as LogisticPostalCode;
        } catch (error) {
            console.error('Error update LogisticPostalCode:', error);
            return null;
        }
    }

    async deleteLogisticPostalCode(
        input: DeleteLogisticPostalCodeInput
    ): Promise<LogisticPostalCode> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteLogisticPostalCode,
                    variables: {
                        input
                    }
                })
            ).data.deleteLogisticPostalCode;
            if (date) return date as LogisticPostalCode;
        } catch (error) {
            console.error('Error delete LogisticPostalCode:', error);
            return null;
        }
    }
}
